<template>
    <b-row class="tests-page-content">
        <b-col cols="12" md="12" lg="3">
            <tests-nav></tests-nav>
        </b-col>
        <b-col cols="12" md="12" lg="9">
            <tests-list type="active"></tests-list>
        </b-col>
    </b-row>

</template>

<script>
    export default {
        name: 'tests-active',
        beforeRouteEnter(to, from, next) {
            window._store.dispatch('tests/index', 'active').then(next).catch(e => {
                // [P] TODO: Add errors handling
            });
        }
    }
</script>

<style scoped>

</style>
